export default __webpack_public_path__ + "static/media/culo.5b188a98.png";